import Image from 'next/image';
import { defaultDonationCampaigns } from 'types';
import marchMadness from '../../assets/events/march-madness.jpg';
import homeTeam from '../../assets/how-to-help/hometeam.png';
import { ClientOnly } from '../../components/general/force-client';
import { Meta } from '../../components/meta/meta';
import { DonateForm } from '../donate';

export default function LudwigEamighMarchMadness() {
  return (
    <>
      <Meta
        title="Ludwig-Eamigh March Madness"
        description="Join Mara and Kevin in supporting Beds for Kids with our 2024 March Madness Challenge!"
        blueTopArch
      />

      <main className="lg:py-8">
        <div className="mx-auto max-w-52 items-center">
          <Image alt="Beds for Kids Home Team Logo" src={homeTeam} className="mx-auto" />
        </div>
        <section className="px-4 text-blue-500 lg:px-0">
          <h1 className="mx-auto my-4 max-w-3xl text-center font-operetta text-4xl md:text-6xl">
            march madness challenge
          </h1>
          <p className="mx-auto max-w-3xl px-4 text-center font-avenir text-xl leading-6">
            Join Mara and Kevin in supporting Beds for Kids with our 2024 March Madness Challenge! Come to our house for
            a tournament kickoff party on <span className="font-semibold">March 19th at 6:30pm.</span> Watch a game,
            have some appetizers and drinks, and help us support this great organization.
          </p>
          <p className="mx-auto mt-8 max-w-3xl px-4 text-center font-avenir text-xl leading-6">
            We encourage everyone to submit a bracket ($150 per entry; paid to Kevin) as well as donate to this worthy
            cause using the form below - even if you can’t come in person. The winner will take home 70% of the entry
            fees and second place will get 30%.{' '}
            <span className="font-semibold">
              Kevin and Mara will match any portion of winnings donated along with all entry fees.
            </span>
          </p>
          <p className="mx-auto mt-8 max-w-3xl px-4 text-center font-avenir text-xl font-semibold leading-6">
            RSVP:{' '}
            <a
              href="mailto:kevin.eamigh@outlook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-blue-400">
              kevin.eamigh@outlook.com
            </a>{' '}
            |{' '}
            <a
              href="tel:6024186908"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-blue-400">
              (602) 418-6908
            </a>
          </p>
        </section>
        <section className="mt-16 flex flex-col items-center gap-2 px-4 text-center text-blue-500 lg:px-0">
          <a
            href="https://fantasy.espn.com/tc/sharer?challengeId=240&from=espn&context=GROUP_INVITE&edition=espn-en&groupId=0b8b2b44-5148-4c7d-bedd-d8e2fee8fa95&joinKey=8e3f7572-81f7-3be2-b03b-8b71532e3ed3"
            target="_blank"
            rel="noopener noreferrer"
            className="font-avenir text-xl font-semibold leading-6 hover:text-blue-400 hover:underline">
            Create your bracket! (group password: <span className="font-semibold">B4KHomeTeam</span>)
          </a>
          <a
            href="https://fantasy.espn.com/tc/sharer?challengeId=240&from=espn&context=GROUP_INVITE&edition=espn-en&groupId=0b8b2b44-5148-4c7d-bedd-d8e2fee8fa95&joinKey=8e3f7572-81f7-3be2-b03b-8b71532e3ed3"
            target="_blank"
            rel="noopener noreferrer">
            <Image
              src={marchMadness}
              alt="March Madness"
              className="mx-auto w-full max-w-lg rounded-lg hover:shadow-lg"
            />
          </a>
        </section>
        <section className="mt-16">
          <h2 className="mx-auto my-4 max-w-3xl text-center font-operetta text-4xl text-blue-500 md:text-5xl">
            donate now!
          </h2>
          <ClientOnly>
            <DonateForm fixedCampaign={defaultDonationCampaigns.ludwigEamighMarchMadness2024} noRecurring />
          </ClientOnly>
        </section>
      </main>
    </>
  );
}
